import {Button, Typography} from "@mui/material";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;


  const handleStep = (value) => {
    // handleStep1 logic here
    props.handleStep(value); // move to any step dynamically
  };
  return (
    <div className="card-info">
      <Typography variant="h1">{i18n.invoice_title}</Typography>
      <div className="invoice-edit">
        <img src="./images/pen.svg" alt="pen" onClick={() => handleStep(0)} />

        <Typography variant="span">{i18n.invoice_edit}</Typography>
      </div>
      <div className="invoice-card">
        <div className="invoice-address">
          <Typography className="text" variant="p">
            {i18n.invoice_address}
          </Typography>
          <p>{props.orderSubscription.companyName}</p>
          <p>{props.orderSubscription.streetHouseNumber}</p>
          <p>
            {props.orderSubscription.zipCode} {props.orderSubscription.city}{" "}
            {props.orderSubscription?.country?.label}
          </p>
        </div>
        <div style={{width: "100%"}}>
          <div className="invoice-email">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <div className="text">Rechnungsversand</div>
              {/* <div>{props.orderSubscription.email}</div> */}
              <div>Elektronisch (per Email)</div>
            </div>
            <div className="text-line">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                <div className="text-mail">Versand an</div>
                <div>{props.orderSubscription.invoiceEmail}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
